<template>
    <div class="aside content">
        <div>
            <div class="logo">
                <img :src="isMobile?image_logo_64:image_logo" alt="">
            </div>
              <div class="side-list">
                 <div v-if="router==='TEMP'&&item.show" @click="handleSelect(item.path)"
                     v-for="item in sideList.tempControl" :key='item.path' class="side-item"
                     :class="{'is-active':$route.path==item.path}">
                    <p>
                        <i v-if="!isMobile" class="iconfont" :class="item.icon"></i>{{item.name}}</p>
                </div>
                <div v-if="router==='MTEMP'&&item.show"  @click="handleSelect(item.path)" v-for="item in sideList.MtempControl" :key='item.path' class="side-item"
                     :class="{'is-active':$route.path==item.path}">
                    <p>
                        <i v-if="!isMobile" class="iconfont" :class="item.icon"></i>{{item.name}}</p>
                </div>
                <div v-if="router==='WATER'&&item.show" @click="handleSelect(item.path)"
                     v-for="item in sideList.allocateWater" :key='item.path' class="side-item"
                     :class="{'is-active':$route.path==item.path}">
                    <p>
                        <i v-if="!isMobile"  class="iconfont" :class="item.icon"></i>{{item.name}}</p>
                </div>
                <template v-if="router==='USER'">
                    <div @click="handleSelect(item.path)" v-for="item in sideList.user" class="side-item"
                         :key='item.path' :class="{'is-active':$route.path==item.path}">
                        <p>
                            <i v-if="!isMobile"  class="iconfont" :class="item.icon"></i>{{item.name}}</p>
                    </div>
                </template>
            </div>

            <div class="bottom-menu" >
                 <template v-if="userInfo.identity==='CUSTOMER'">
                <div  @click="handleSelect(item.path)"
                     v-if="(item.path!=='/user?sider=true'||router!=='USER')&&item.identity==='CUSTOMER'" :key='item.path'
                     v-for="item in sideList.bottom" class="side-item"
                     :class="{'is-active':$route.path==item.path}">
                    <p>
                        <i v-if="!isMobile"  class="iconfont" :class="item.icon"></i>{{item.name}}</p>
                </div>
               </template>
                 <template v-if="userInfo.identity==='USER'">
                 <div  @click="handleSelect(item.path)"
                     v-if="item.identity==='USER'"
                     :key='item.path'
                     v-for="item in sideList.bottom" class="side-item"
                     :class="{'is-active':$route.path==item.path}">
                    <p>
                        <i class="iconfont" v-if="!isMobile" :class="item.icon"></i>{{item.name}}</p>
                </div>
               </template>

            </div>
        </div>
    </div>
</template>

<script>
const image_logo = require("../../assets/images/leemma logo.png");
const image_logo_64 = require("../../assets/images/leemma64x64.png");
// TODO 侧边栏的收回
import { mapState } from "vuex";
import Lib from "../../lib/lib";

export default {
  name: "pageSide",
  data() {
    return {
      image_logo,
image_logo_64,
      activeIndex: "",
      router: this.$route.hash,
      isshow: true,
      sideList: {
        user: [
          { path: "/user/deviceList", name: "设备列表",Mname:'设备', icon: "icon-all" }
          // { path: '/user/msgList', name: '消息中心', icon: 'icon-tixing' },
          // { path: '/user/setting', name: '账号设置', icon: 'icon-setup_fill' },
        ],
        tempControl: [
          {
            path: "/tempControl/realData",
            name: "工艺曲线",Mname:'工艺',
            icon: "icon-shishibaobiao"
          },
          {
            path: "/tempControl/historyData",
            name: "产量统计",Mname:'产量',
            icon: "icon-xiangxi"
          },
          {
            path: "/tempControl/controlSet",
            name: "控制参数",Mname:'控制',
            icon: "icon-xitongcanshushezhi"
          },
          {
            path: "/tempControl/standardSet",
            name: "标准参数",Mname:'标准',
            icon: "icon-leijianzhuxiulix"
          },

          {
            path: "/tempControl/autoVal",
            name: "控制变量",Mname:'变量',
            icon: "icon-text",
            identity: "USER"
          },
          {
            path: "/tempControl/deviceConf",
            name: "设备配置",Mname:'配置',
            icon: "icon-sitting",
            identity: "USER"
          }
        ],
         MtempControl: [
          {
            path: "/MtempControl/realData",
            name: "工艺曲线",Mname:'工艺',
            icon: "icon-shishibaobiao"
          },
          {
            path: "/MtempControl/historyData",
            name: "产量统计",Mname:'产量',
            icon: "icon-xiangxi"
          },
          {
            path: "/MtempControl/controlSet",
            name: "控制参数",Mname:'控制',
            icon: "icon-xitongcanshushezhi"
          },
          {
            path: "/MtempControl/standardSet",
            name: "标准参数",Mname:'标准',
            icon: "icon-leijianzhuxiulix"
          },

          {
            path: "/MtempControl/autoVal",
            name: "控制变量",Mname:'变量',
            icon: "icon-text",
            identity: "USER"
          },
          {
            path: "/MtempControl/deviceConf",
            name: "设备配置",Mname:'配置',
            icon: "icon-sitting",
            identity: "USER"
          }
        ],
        allocateWater: [
          {
            path: "/allocate/realData",
            name: "实时数据",Mname:'实时',
            icon: "icon-shishibaobiao",
          },
          {
            path: "/allocate/outputData",
            name: "统计报告",Mname:'统计',
            icon: "icon-xiangxi"
          },
          {
            path: "/allocate/controlConf",
            name: "控制参数",Mname:'控制',
            icon: "icon-xitongcanshushezhi"
          },
          {
            path: "/allocate/standConf",
            name: "标准参数",Mname:'标准',
            icon: "icon-leijianzhuxiulix"
          },
            {
            path: "/allocate/autoVal",
            name: "控制变量",Mname:'变量',
            icon: "icon-text",
            identity: "USER"
          },
          {
            path: "/allocate/deviceConf",
            name: "设备配置",Mname:'配置',
            icon: "icon-sitting",
            identity: "USER"
          }
        ],
        bottom: [
          {
            path: "/user?sider=true",
            name: "返回列表",Mname:'列表',
            icon: "icon-undo",
            identity: "CUSTOMER"
          },
          {
            path: "/logout/",
            name: "退出登录",Mname:'退出',
            icon: "icon-tuichu",
            identity: "CUSTOMER"
          },
          {
            path: "services.leemma.com",
            name: "返回管理后台",Mname:'返回',
            icon: "icon-tuichu",
            identity: "USER"
          }
        ]
      }
    };
  },
  computed: mapState({
    isOpen: function(state) {
      return state.siderbarOpen;
    },
    isMobile: state => state.isMobile,
    userInfo: state => state.userInfo,
    devceInfo: state => state.deviceInfo
  }),
  created() {
    this.showRouteName();
  },
  watch: {
    $route: "showRouteName"
  },
  methods: {
    handleSelect(keyPath) {
      //logout
      if (keyPath === "logout") {
        this.logout();
      } else if (keyPath === "services.leemma.com") {
        location.href = "https://services.leemma.com";
      } else {
        this.$router.push(keyPath);
      }
      //手机端隐藏侧栏
      if (this.isMobile) {
        this.$store.dispatch("toggleSide");
      }
    },
    // 检测权限
    checkIdentity(arr) {
      arr.forEach(item => {
        if (item.identity === "USER" && this.userInfo.identity !== "USER") {
          item.show = false;
        } else {
          item.show = true;
        }
        if(this.devceInfo.category==='配煤'&&item.name==='控制参数'){
            item.show=false
        }
        if(this.devceInfo.category==='配水'&&item.name==='标准参数'){
            item.show=false
        }
      }, this);
    },
    // 登出并跳转到登陆页
    logout() {
      let params = {
        customer_token: this.userInfo.token
      };
      Lib.api.logout(params, data => {
        this.$message("登出成功");
      });
    },
    showRouteName() {
      let routeSearch = text => {
        if (this.$route.path.search(text) === 1) {
          return true;
        } else {
          return false;
        }
      };
      if (routeSearch("tempControl")) {
        this.router = "TEMP";
      } else if (routeSearch("allocate")) {
        this.router = "WATER";
      }else if(routeSearch("MtempControl")){
          this.router='MTEMP'
      } else {
        this.router = "USER";
      }
      this.checkIdentity(this.sideList.tempControl);
      this.checkIdentity(this.sideList.MtempControl);
      this.checkIdentity(this.sideList.allocateWater);

    }
  }
};
</script>

<style scoped>
.content {
  display: block;
  z-index: 999;
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.15);
  background: #2f323a;
}

.logo img {
  width: 94%;
  margin: 14px 0;
}

.side-item {
  background: #2f323a;
  font-size: 0.2rem;
  height: 80px;
  line-height: 80px;
  color: #999eae;
  padding: 0 20px;
  cursor: pointer;
  position: relative;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  box-sizing: border-box;
  white-space: nowrap;
}

.side-item .iconfont {
  font-size: 0.3rem;
  vertical-align: baseline;
  margin: 0 30px 0 10px;
  width: 24px;
  text-align: center;
}

.side-item p {
  display: flex;
  align-items: center;
}

.side-item.is-active {
  background: #545454;
  color: white;
}

.side-item:hover {
  background: rgba(84, 84, 84, 0.7);
}

.user-info {
  margin: 20px 0;
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.18rem;
  position: relative;
  color: rgba(113, 186, 255, 1.3);
}

.user-info .user-img {
  margin: 5px;
  background: black;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: inline-block;
}

.user-info p {
  font-weight: bold;
  /* position: relative */
}

.user-info p > i {
  font-size: 0.32rem;
  position: absolute;
  right: 30px;
  top: 38px;
  cursor: pointer;
}

.bottom-menu {
  position: absolute;
  bottom: 0px;
  width: 100%;
}

/* .bottom-menu .side-item {
} */

@media (max-width: 800px) {
  .side-item .iconfont {
    font-size: 0.2rem;
    vertical-align: baseline;
    margin: 0 10px 0 0;
    width: 24px;
    text-align: center;
  }

  .side-item {
       font-size: 0.16rem;
    height: 41px;
    line-height: 41px;
    padding: 0px 10px;
  }

  .logo > img {
  margin: 11px auto;
    display: block;
    width: 63%;
  }
}
</style>



// WEBPACK FOOTER //
// pageSide.vue?8b03852a